import React from 'react';
import { Image } from 'react-native';
import type { PostProps, PublicPlayerProps } from '../../../types';
import moment from 'moment-mini';
import { Button, Text, View } from '../../../Components/Themed';

type PostHeaderProps = {
    player: PublicPlayerProps,
    post:PostProps,
    onSelectPlayer:(p:PublicPlayerProps) => void
}

const PostHeader = ({ player, post, onSelectPlayer }:PostHeaderProps) => {
    return (
        <View type='header'>
            <Button transparent style={{ flexDirection:'row', alignItems:'center', padding:10 }} onPress={() => onSelectPlayer(player)}>
                <Image
                    source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:32, width:32, borderRadius:100 }}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h2'>{player.first_name} {player.last_name}</Text>
                    <Text style={{ marginTop:3 }} theme='description'>@{player.username} • {moment(post.create_datetime).fromNow()}</Text>
                </View>
            </Button>
        </View>
    )
}

export default PostHeader